import {ACTIONS} from '../actions/Actions'

const credits = (state = [], action) => { 
    switch  (action.type){
    case ACTIONS.credits.index.statuses.completed: {
	return Object.assign([], action.data)
	break;
    }
	
    default:
	return state
    }
}
export default credits
